import React from 'react'
import { Field } from 'redux-form';
import { Item, painel, fieldset } from 'scorpion-core';

import ListaHistorico from './components/ListaHistorico'

function componentRelEspelho(comp, dados) {
    return ""
}


function component(item, props) {
    return (<ListaHistorico customForm={props.customForm} uidObj={props.atualValues ? props.atualValues.uid : ""} />)
}

const modelo = { label: "Histórico", typeComponente: "HistoricoComponente" }

const comp = {
    typeComponente: "HistoricoComponente",
    configView: {
        nome: "Histórico",
        modelo

    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Historico/index.js